import React from 'react';
import { Page } from '@axiom/ui';
import { Outlet } from 'react-router-dom';

import AppContainer from '../components/AppContainer/AppContainer';

export const BenchPage = () => {
  return (
    <Page title="AxiomLaw - Bench">
      <AppContainer>
        <Outlet />
      </AppContainer>
    </Page>
  );
};
